/**
 * Dialing components rendering the Call us information:
 * Customer Phone number, Cusomter Service Hour, Sepcial Instruction, Webpin, MTS/AM phone number/hour, Hard code PP credit number
 */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// Helper
import l10n from '../../lib/reactPPl10nHelper';
import Page from '../../lib/page';
import { CALL_US_CONTACT_INFO, CONTACT_OPTION, TOPIC_TREE_SELECT_RESULT } from '../constants/PropTypesShapes';
import dispatchLogin from '../actions/action-login-redirect';
import doMobileWebHelpIvrAuth from '../actions/action-ivr-auth-web';
import { trackLink } from '../../lib/analytics-helper';

import RelatedOptions from '../containers/RelatedOptions';
import GoogleStructuredData from './common/GoogleStructuredData';
import ColumnLayout from './common/ColumnLayout';
import RequestACall from './RequestACall';
import {
  urlConstants,
  asyncOrigins,
  chatBotMessageUsRefIdsMapping,
  contactChannels,
} from '../../common/commonConstants';

import {
  getC3MarketChannelEligibility,
  isNodeChatAlreadyExists,
} from '../../lib/globalHelper';
import { initiateAsyncChat, isMessageUsAvailable } from '../../lib/asyncMessageHelper';
import { loadModalContainer } from '../actions/action-login-modal';
import { setChatCardClickInSession, setLiveChatClickInSession } from '../../lib/chat-bot-live-helper';

const label = {
  loginBtn: l10n.getContent('smarthelp/callUs.login.login'),
  logoutInst: l10n.getContent('smarthelp/callUs.call.dialing.customer.logout.inst'),
  dialingSubHeader: l10n.getContent('smarthelp/callUs.call.dialing.customer.subInst.header'),
  dialingSubBody: l10n.getContent('smarthelp/callUs.call.dialing.customer.subInst.body'),
  additionInst: l10n.getContent('smarthelp/callUs.callUs.splInstruction'),
  serviceHourHeader: l10n.getContent('smarthelp/callUs.call.dialing.service.hour.headr'),
  subHoursHeader: l10n.getContent('smarthelp/callUs.call.dialing.service.hour.subHeadr'),
  webpinHeader: l10n.getContent('smarthelp/callUs.call.dialing.webpin.header'),
  webpinInst: l10n.getContent('smarthelp/callUs.call.dialing.webpin.spInst'),
  webpinSubHeader: l10n.getContent('smarthelp/callUs.call.dialing.webpin.subHeader'),
  webpinNotice: l10n.getContent('smarthelp/callUs.call.dialing.webpin.subInst'),
  webpinNoticeAlt: l10n.getContent('smarthelp/callUs.call.dialing.webpin.subInstAlt'),
  accountMTS: l10n.getContent('smarthelp/callUs.callUs.accountManage.MTS'),
  mobileLogoutInst: l10n.getContent('smarthelp/callUs.call.dialing.mobile.logout.inst'),
  generalHeader: l10n.getContent('smarthelp/callUs.callUs.generalFlag'),
  fundsAvailability: l10n.getContent('smarthelp/callUs.callUs.newFundsAvailability', { fundsUrl: urlConstants.FUNDS_URL }),
  callUsLink: l10n.getContent('smarthelp/contactOption.callUs.header'),
  mobileCallHeader: l10n.getContent('smarthelp/callUs.call.dialing.mobile.callHeader'),
  mobileCallSubHeader: l10n.getContent('smarthelp/callUs.call.dialing.mobile.callSubHeader.passcode'),
  serviceHoursHeader: l10n.getContent('smarthelp/callUs.callUs.serviceHours'),
  callMessageUsHeaderText: l10n.getContent('smarthelp/callUs.call.additionOptions.messageUs.headerText'),
  callusMessageLabel: l10n.getContent('smarthelp/contactOption.messageUs.text'),
};

const isLoggedIn = Page.isLoggedIn();
const fundsNowAvailable = Page.isFundsNowInstantAvailable();

class Dialing extends Component {
  // Main call us container css style; placeholder for additional layout change
  static getMainContainerStyle() {
    return classNames({
      'channel-new-dialing-container': true,
    });
  }

  static mobileIVRFptitracker(number, webPin, webIvrCall) {
    // Only for Mobile Devices - Fire CSAuth calls & webIvrCall helps set Mayfly context
    if (typeof webIvrCall === 'function' && isLoggedIn && Page.isMobileauthwebStepupEnabledCountries()) {
      // use cases - only in Logged In
      /*
        1. Desktop Call Step Up
        2. Mobile Web Call Step Up
        3. Mobile Web Auth carry over
        4. Placing Web Pin if it exists
       */
      trackLink({
        id: 'callPage',
        link: `webPinStepUpCSAuth|call|${number}|isMobile:${Page.isMobileLayout()}|hasWebPin:${!!webPin}|isMobileauthwebStepupEnabledCountries:${Page.isMobileauthwebStepupEnabledCountries()}`,
      });
      return webIvrCall({ webPin: webPin || null, number });
    }
    return null;
  }

  static phoneNumberClickTracker(event, number, webPin, webIvrCall) {
    event.preventDefault();
    Dialing.mobileIVRFptitracker(number, webPin, webIvrCall);
    trackLink({ id: 'callPage', link: `channel-dialing|call|${number}` });
    return window.open(`tel:${number}`, '_self');
  }

  // If mobile device layout and is remote config enabled display Call us link instead of a phone number.
  // By default displays phone number if the conditions doesn't met.
  static renderCallUsLink(number, webPin, webIvrCall) {
    if (Page.isMobileLayout() && Page.isMobileWebCallUsLinkEnabled()) {
      return (
        <div className="channel-new-call-icon-section">
          <span className="call-phone-icon" />
          <a href={`tel:${number}`} className="channel-new-call-contact-number" onClick={(e) => Dialing.phoneNumberClickTracker(e, number, webPin, webIvrCall)}>
            {label.callUsLink}
          </a>
        </div>
      );
    }

    return (
      <a href={`tel:${number}`} className="channel-new-call-contact-number" onClick={(e) => Dialing.phoneNumberClickTracker(e, number, webPin, webIvrCall)}>
        {number}
      </a>
    );
  }

  // Render all the number in the `numbers` array
  static renderPhoneNumber(numbers, webPin, webIvrCall) {
    if (!Array.isArray(numbers)) {
      return null;
    }
    if (Page.isMobileLayout()) {
      return (
        <div className="channel-new-call-number-item">
          {Dialing.renderCallUsLink(numbers[0], webPin, webIvrCall)}
          <GoogleStructuredData
            type="Organization"
            data={{ url: Page.getCurrentLocationURL(), telephone: numbers[0], department: 'Customer Service' }}
          />
        </div>
      );
    }
    return numbers.map((number) => (
      <div className="channel-new-call-number-item">
        {Dialing.renderCallUsLink(number, webPin, webIvrCall)}
        <GoogleStructuredData
          type="Organization"
          data={{ url: Page.getCurrentLocationURL(), telephone: number, department: 'Customer Service' }}
        />
      </div>
    ));
  }

  // Iterate all the customer hour object and render the validate/existed hours
  static serviceHourItem(options) {
    if (!options || !options.key || !options.value) {
      return null;
    }

    return (
      <li className="new-service-hour-item" key={options.key}>
        {Page.getHTMLElement({ message: options.value, useHTML: true })}
      </li>
    );
  }

  static loginLinkStyle() {
    return classNames({
      'channel-new-dialing-login-btn': true,
      no_extra_space_callus: Page.isNoExtraSpaceLocale(),
    });
  }

  constructor(props) {
    super(props);
    this.loginClickHandler = this.loginClickHandler.bind(this);
  }

  getWebPin() {
    return (isLoggedIn && this.props.contactInfo && this.props.contactInfo.webPin) ? this.props.contactInfo.webPin : null;
  }

  // Checking for webpin existance
  hasWebPin() {
    return this.props.contactInfo && this.props.contactInfo.webPin;
  }

  hasPPCustomerServiceNumber() {
    return this.props.contactInfo && Array.isArray(this.props.contactInfo.phoneNumber) && this.props.contactInfo.phoneNumber.length;
  }

  loginClickHandler() {
    trackLink({ id: 'callPage', link: 'channel-dialing-login' });
    const currentURI = Page.getCurrentURI();
    return this.props.dispatchLogin(currentURI, 'callUs');
  }

  messageUsClicked() {
    // making chat card clicked true after pilot user clicks on message us contact card in callus
    setLiveChatClickInSession(true);
    setChatCardClickInSession(true);

    trackLink({ id: 'callPage', link: 'help-options|message' });
    if (Page.isLoggedIn()) {
      // Check if messageUs window is already opened in logged in state.
      // If already exists do not perform any operations and plush an FPTI.
      if (isNodeChatAlreadyExists()) {
        return trackLink({ id: 'callPage', link: 'help-options|message|messageUs-window-already-open' });
      }

      // Initiate Async Chat/Message Us
      return initiateAsyncChat({ topicRefId: chatBotMessageUsRefIdsMapping.GENPOOL_CONTACT_US, origin: asyncOrigins.CALL_US_TRAY });
    }
    return this.props.loadModalContainer('messageUs', 'smc');
  }

  // Message Us card component
  renderMessageUsCard() {
    const manageNumber = this.props.contactInfo && this.props.contactInfo.amPhone;
    const managerEmail = this.props.contactInfo && this.props.contactInfo.accountManagerEmail;
    // Hide message us option when AM data is present
    // and if country is enabled and channel is not present in c3merchantMigration remoteconfig and c2merchantflag should be false
    if (isMessageUsAvailable(this.renderContactOptions()) && !manageNumber && !managerEmail && getC3MarketChannelEligibility(contactChannels.MESSAGE_CENTER)) {
      return (
        <div className="message-us-card message-us-card--sh-card-md" id={`new-callus-${contactChannels.MESSAGE_CENTER}-link`} onClick={() => this.messageUsClicked()}>
          <div className={`message-us-card--contact-icon message-us-card--sh-card-md--contact-icon--icon-${contactChannels.MESSAGE_CENTER}`} aria-hidden="true" />
          <div className="message-us-card--contact-labels message-us-card--sh-card-md--contact-labels">
            <button className="message-us-card--contact-button-label message-us-card--sh-card-md--contact-button-label">{label.callMessageUsHeaderText}</button>
            <p>{label.callusMessageLabel}</p>
          </div>
        </div>
      );
    }
    return <div />;
  }

  /**
   * fetching default contact options from window and final intent contact options from state
   */
  renderContactOptions() {
    const { selectResult, contactOptions } = this.props;
    if (selectResult.topicsDisplay) {
      return Page.getIDIContactOptionDecisions();
    }
    return contactOptions;
  }

  // render funds-now-product available
  renderFundsNowInstantLabel() {
    if (!fundsNowAvailable || this.props.contactInfo.ppCreditTopics) return null;
    return (
      <div className="channel-new-call-dialing-inst-body">{Page.getHTMLElement({ message: label.fundsAvailability, useHTML: true })}</div>
    );
  }

  // Displaying login message for logout users
  renderLoginMsg() {
    if (isLoggedIn) {
      return null;
    }

    return (
      <div className="channel-new-dialing-logout-msg">
        <button className={Dialing.loginLinkStyle()} onClick={this.loginClickHandler}>{label.loginBtn}</button>
        <span className="channel-new-dialing-login-inst channel-new-call-dialing__desktop">{this.props.contactInfo.logoutInst}</span>
        <span className="channel-new-dialing-login-inst channel-new-call-dialing__mobile">{this.props.contactInfo.mobileLogoutInst}</span>
      </div>
    );
  }

  // Show call header for PayPal customers and MTS/AM accounts
  renderDialingHeader() {
    // if neither paypal customer number nor webpin, return null
    if (!this.hasPPCustomerServiceNumber() && !this.hasWebPin()) {
      return null;
    }

    const desktopHeader = this.props.contactInfo.header;
    const mobileHeader = this.props.contactInfo.mobileHeader || this.props.contactInfo.header;

    return (
      <div>
        <h2 className="channel-new-call-dialing-inst-header channel-new-call-dialing__desktop">{desktopHeader}</h2>
        <h2 className="channel-new-call-dialing-inst-header channel-new-call-dialing__mobile">{mobileHeader}</h2>
      </div>
    );
  }

  // Show call header for PayPal customers and MTS/AM accounts ( Mobile Auth Callers)
  renderDialingHeaderForAuthCallers() {
    // if neither paypal customer number nor webpin, return null
    if (!this.hasPPCustomerServiceNumber() && !this.hasWebPin()) {
      return null;
    }
    return (
      <div>
        <h2 className="channel-new-call-dialing-inst-header channel-new-call-dialing__mobile">{label.mobileCallHeader}</h2>
      </div>
    );
  }

  renderCallusWebpin() {
    // For changing the position for phone number when webpin exists
    return !!this.getWebPin();
  }

  // Render Customer Service number from SAC or PPC hardcode data
  renderCustomerServiceNumber() {
    if (!this.hasPPCustomerServiceNumber()) {
      return null;
    }

    const dialingNumberClassName = this.renderCallusWebpin() ? 'channel-new-call-dialing-numbers call-webpin' : 'channel-new-call-dialing-numbers';
    return (
      <div>
        <div className={dialingNumberClassName}>
          {Dialing.renderPhoneNumber(this.props.contactInfo.phoneNumber, this.getWebPin(), this.props.doMobileWebHelpIvrAuth)}
        </div>
      </div>
    );
  }

  // Render Customer Service number from SAC or PPC hardcode data
  renderCustomerServiceNumberForAuthCallers() {
    if (!this.hasPPCustomerServiceNumber()) {
      return null;
    }

    const dialingNumberClassName = this.renderCallusWebpin() ? 'channel-new-call-dialing-numbers call-webpin' : 'channel-new-call-dialing-numbers';
    return (
      <div>
        <div className={dialingNumberClassName}>
          {Dialing.renderPhoneNumber(this.props.contactInfo.phoneNumber, this.getWebPin(), this.props.doMobileWebHelpIvrAuth)}
        </div>
      </div>
    );
  }

  renderSubInstructionsMessageForAuthCallers() {
    return (
      <div>
        {this.renderFundsNowInstantLabel()}
        <div className="channel-new-call-dialing-inst-body">{label.dialingSubBody}</div>
      </div>
    );
  }

  // Render MTS account numbers
  renderTechNumber() {
    const techNumber = this.props.contactInfo.generalMTS || this.props.contactInfo.mtsPhone;
    if (!techNumber) {
      return null;
    }

    return (
      <div>
        <h2 className="channel-new-call-dialing-inst-header">{label.accountMTS}</h2>
        {Dialing.renderPhoneNumber([techNumber])}
      </div>
    );
  }

  // Render AM account numbers
  renderManagementNumber() {
    const manageNumber = this.props.contactInfo && this.props.contactInfo.amPhone;
    const managerEmail = this.props.contactInfo && this.props.contactInfo.accountManagerEmail;
    if (!manageNumber && !managerEmail) {
      return null;
    }

    return (
      <div>
        <h2 className="channel-new-call-dialing-inst-header">{l10n.getContent('smarthelp/callUs.callUs.accountManage.flag', { flageName: this.props.contactInfo.amFlag || '' })}</h2>
        {Dialing.renderPhoneNumber([manageNumber])}
        <label htmlFor="managerEmail" className="channel-new-call-account-email">{managerEmail}</label>
      </div>
    );
  }

  // Render General Phone numbers
  renderGeneralPhoneNumber() {
    const generalNumber = this.props.contactInfo.generalPhoneNumber;
    if (!generalNumber) {
      return null;
    }

    return (
      <div>
        <h2 className="channel-new-call-dialing-inst-header">{label.generalHeader}</h2>
        {Dialing.renderPhoneNumber([generalNumber])}
      </div>
    );
  }

  // Render Special instruction from SAC
  renderSpecialInstruction() {
    if (!this.props.contactInfo || !this.props.contactInfo.specialInstruction) {
      return null;
    }

    return (
      <div className="channel-new-call-special-instruction">
        {Page.getHTMLElement({ message: this.props.contactInfo.specialInstruction, useHTML: true })}
      </div>
    );
  }

  // Render Service hour from SAC or hardcode PPC data
  renderSeriveHour() {
    // Checking the whether the service hour exist or not; TODO: update for MTS/AM/PPC service hour logic
    if (!this.props.contactInfo || !this.props.contactInfo.customerHour) {
      return null;
    }

    const serviceHour = Object.entries(this.props.contactInfo.customerHour).map((item) => Dialing.serviceHourItem({ key: item[0], value: item[1] }));

    // Null check for service hour
    if (serviceHour.every((hour) => !hour)) {
      return null;
    }

    return (
      <div className="channel-new-call-service-hours-container">
        <h2 className="channel-new-call-customer-hours-title">{label.serviceHoursHeader}</h2>
        <div className="channel-new-call-customer-hours">
          <ul className="channel-new-call-customer-hours-body">
            {serviceHour}
          </ul>
        </div>
      </div>
    );
  }

  // Render Wep Pin for login users
  renderWebpin() {
    if (!isLoggedIn || !this.hasWebPin()) {
      return null;
    }

    // Using remove config to switch webpin
    const webpinNotice = Page.checkIsCustomWebPinTooltipEnabled() === 'true' ? label.webpinNoticeAlt : label.webpinNotice;

    return (
      <div className="channel-new-call-webpin-container">
        <div className="channel-new-call-webpin-instruction">{label.webpinInst}</div>
        <div className="channel-new-call-webpin-message-content">
          <div className="channel-new-call-webpin-content-header">{label.webpinSubHeader}</div>
          <div className="channel-new-call-webpin-content-body">{this.props.contactInfo.webPin}</div>
        </div>
        <div className="channel-new-call-webpin-content-notice">{webpinNotice}</div>
      </div>
    );
  }

  // Render Wep Pin for login user with MobileAuth enabled
  renderWebpinForMobileWebauthCallers() {
    if (!isLoggedIn || !this.hasWebPin()) {
      return null;
    }

    // Using remove config to switch webpin
    const webpinNotice = Page.checkIsCustomWebPinTooltipEnabled() === 'true' ? label.webpinNoticeAlt : label.webpinNotice;

    return (
      <div className="channel-new-call-webpin-container">
        <div className="channel-new-call-webpin-message-content">
          <div className="channel-new-call-webpin-content-header">{label.webpinSubHeader}</div>
          <div className="channel-new-call-webpin-content-body">{this.props.contactInfo.webPin}</div>
        </div>
        <div className="channel-new-call-webpin-content-notice">{webpinNotice}</div>
      </div>
    );
  }

  // Render Customer service/PPC/MTS/AM Phone number
  renderDialingPhoneInfo() {
    if (Page.isMobileLayout() && Page.isMobileauthwebStepupEnabledCountries()) { // Mobile web and Mo
      return (
        <div className="channel-new-dialing-phone-main-content">
          {this.renderLoginMsg()}
          {<RequestACall />}
          {this.renderDialingHeaderForAuthCallers()}
          {this.renderWebpinForMobileWebauthCallers()}
          {this.renderCustomerServiceNumberForAuthCallers()}
          {this.renderTechNumber()}
          {this.renderManagementNumber()}
          {this.renderGeneralPhoneNumber()}
          {this.renderDialingInstruction()}
          {this.renderSubInstructionsMessageForAuthCallers()}
          <div className="channel-new-call-dialing-addition-inst">{label.additionInst}</div>
        </div>
      );
    }
    return (
      <div className="channel-new-dialing-phone-main-content">
        {this.renderLoginMsg()}
        {<RequestACall />}
        {this.renderDialingHeader()}
        {this.renderWebpin()}
        {this.renderTechNumber()}
        {this.renderManagementNumber()}
        {this.renderCustomerServiceNumber()}
        {this.renderGeneralPhoneNumber()}
        {this.renderDialingInstruction()}
        {this.renderSubInstructionsMessageForAuthCallers()}
        <div className="channel-new-call-dialing-addition-inst">{label.additionInst}</div>
      </div>
    );
  }

  // Render Sepcial Instruction, Customer Service hour and MTS/AM additional data
  renderDialingInstruction() {
    return (
      <div className="channel-new-dialing-instruction-main-content">
        {this.renderSeriveHour()}
        <div className="callus-contact-card">
          {this.renderMessageUsCard()}
        </div>
        {this.renderSpecialInstruction()}
      </div>
    );
  }

  // Render Login style with Webpin section
  renderLoginPhone() {
    const { channels, contactInfo } = this.props;
    const contactOptions = this.renderContactOptions();
    const channelsAvailable = contactOptions && contactOptions.length ? contactOptions : channels;
    const manageNumber = contactInfo && contactInfo.amPhone;
    const managerEmail = contactInfo && contactInfo.accountManagerEmail;
    return (
      <ColumnLayout
        customizeStyle={Dialing.getMainContainerStyle()}
        leftPanel={(
          <div>
            {this.renderDialingPhoneInfo()}
          </div>
        )}
        rightPanel={(
          <div>
            <RelatedOptions contactChannels={channelsAvailable} manageNumber={manageNumber} managerEmail={managerEmail} />
          </div>
        )}
      />
    );
  }

  // render default logout style
  renderLogoutPhone() {
    const { channels } = this.props;
    const contactOptions = this.renderContactOptions();
    const channelsAvailable = contactOptions && contactOptions.length ? contactOptions : channels;
    return (
      <ColumnLayout
        customizeStyle={Dialing.getMainContainerStyle()}
        leftPanel={(
          <div>
            {this.renderDialingPhoneInfo()}
          </div>
        )}
        rightPanel={<RelatedOptions contactChannels={channelsAvailable} />}
      />
    );
  }

  render() {
    // Render Dialing two column style; show webpin when there is webpin in the response
    return (isLoggedIn && this.hasWebPin()) ? this.renderLoginPhone() : this.renderLogoutPhone();
  }
}

Dialing.propTypes = {
  dispatchLogin: PropTypes.func.isRequired,
  doMobileWebHelpIvrAuth: PropTypes.func.isRequired,
  contactInfo: PropTypes.shape(CALL_US_CONTACT_INFO).isRequired,
  loadModalContainer: PropTypes.func.isRequired,
  selectResult: PropTypes.shape(TOPIC_TREE_SELECT_RESULT).isRequired,
  contactOptions: PropTypes.arrayOf(PropTypes.shape(CONTACT_OPTION)).isRequired,
  channels: PropTypes.arrayOf(PropTypes.shape(CONTACT_OPTION)).isRequired,
};

function mapStateToProps(state) {
  return {
    selectResult: state.selectResult,
    contactOptions: state.contactChannels.IDIAvailability,
    channels: state.contactChannels.channels,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ dispatchLogin, doMobileWebHelpIvrAuth, loadModalContainer }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Dialing);
